// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\ntbody tr:nth-of-type(odd) {\r\n  background-color: rgba(0, 0, 0, 0.1);\n}\r\n", ""]);
// Exports
module.exports = exports;
